import React from 'react';
import {useTranslation} from 'react-i18next';
import {useFormContext} from 'react-hook-form';
import {Input, InputProps} from '@chekinapp/ui';

type GuestEmailFieldProps = Pick<
  InputProps,
  | 'label'
  | 'disabled'
  | 'onKeyDown'
  | 'className'
  | 'defaultValue'
  | 'tooltip'
  | 'optional'
  | 'onFocus'
  | 'onBlur'
> & {
  name: string;
  format: RegExp;
  required?: boolean | string;
};

const GuestEmailField = React.memo(
  ({
    name,
    format,
    label,
    required,
    disabled,
    onFocus,
    onBlur,
    ...props
  }: GuestEmailFieldProps) => {
    const {t} = useTranslation();
    const {
      register,
      formState: {errors},
    } = useFormContext();

    return (
      <Input
        label={label}
        {...register(name, {
          required,
          pattern: {
            value: format,
            message: t('invalid_email'),
          },
        })}
        inputMode="email"
        autoCorrect="off"
        spellCheck={false}
        autoCapitalize="none"
        error={errors[name]?.message as string}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        {...props}
      />
    );
  },
);

export {GuestEmailField};
